import React from 'react';
import { Modal } from 'jd-library';
import styles from './commonStyle.scss';

const CategoryModal = props => {
    return (
        <Modal
            settings={{
                modalId: 'ai-modals',
                variant: 'action',
                class: styles["ai-modals"],
            }}
            backdropStatic
            onHidden={props.onHidden}
            onVisible = {() => {props.recordImpression('catReqModal')}}
        >
            <Modal.CloseIcon />
            <Modal.Header className={styles['modal-heading']}>{props.prodServLabel} Category Required </Modal.Header>
            <Modal.Body className={styles['modal-body']}>{props.prodServLabel} category is required for generating a meaningful description</Modal.Body>
            <Modal.CenterButton
                className={styles['cntr-btn']}
                onClick={() => {
                    props.recordImpression('selCatBtn');
                    window.history.back();
                    setTimeout(() => {
                        props.openCloseCatSlider(true);
                    }, 500);         
                    }}
                >
                    Select {props.prodServLabel} Category
                </Modal.CenterButton>
            </Modal>
    )
}

export default CategoryModal;